import { render, staticRenderFns } from "./mdc-drawer.vue?vue&type=template&id=55628598&scoped=true&"
import script from "./mdc-drawer.vue?vue&type=script&lang=ts&"
export * from "./mdc-drawer.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-drawer.vue?vue&type=style&index=0&id=55628598&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55628598",
  null
  
)

export default component.exports